module.exports = __webpack_public_path__ + "img/comment_img2.ebc6e7a5.jpg";